import { PayloadAction } from '@reduxjs/toolkit';

import { CohortType } from 'types/cohorts/cohortOverview';
import { defaultSelectedCohort } from 'redux/utils';
import { SetAllType, SetFieldType, types } from './actions';

const initialState: CohortType = defaultSelectedCohort;

const handleSetAll = (state: CohortType, payload: SetAllType) => payload.cohort;

const handleSetField = (state: CohortType, payload: SetFieldType) => ({ ...state, [payload.field]: payload.value });

const reducer = (state: CohortType, action: PayloadAction<SetAllType | SetFieldType>) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_ALL: {
      return handleSetAll(state, <SetAllType>payload);
    }
    case types.SET_FIELD: {
      return handleSetField(state, <SetFieldType>payload);
    }
    default:
      return state;
  }
}

export { reducer, initialState };
